import React, { useCallback } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  MdKeyboardArrowLeft as ArrowLeftIcon,
} from 'react-icons/md';
import { IconGroup } from './helpContentIconGroup.component';
import { historyPropTypes } from '../../shared/propTypes/historyPropTypes';


const HelpContentNotFound = ({
  history,
  onClose,
}) => {
  const onArrowClick = useCallback(() => {
    if (history.length > 0) {
      history.goBack();
    }
  }, [history]);

  return (
    <div className="HelpContent">
      <h4 className="popup-header">
        <div className="header">
          <div className="popup-header-back-arrow" onClick={onArrowClick}>
            <ArrowLeftIcon/>
          </div>
          <h5>Help Page not found</h5>
          <IconGroup
            readOnly
            onClose={onClose}
          />
        </div>
      </h4>
      <div className="popup-body">
        <div className="HelpContent-not-found">
          Content Not Found. <Link to="/">Go back to Help Menu</Link>
        </div>
      </div>
    </div>
  );
};

HelpContentNotFound.propTypes = {
  history: historyPropTypes.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default HelpContentNotFound;
